<template>
  <div class="background">
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="records"
            :items-per-page.sync="pageSize"
            @update:page="onChangePage($event)"
            @page-count="totalPageCount = $event"
            class="elevation-1"
          >
            <template v-slot:item.tags="{ item }">
              <span>
                <v-chip small v-for="tag in item.tags" :key="tag">
                  {{tag}}
                </v-chip>
              </span>
            </template>
            <template v-slot:item.detail-btn="{ item }">
              <span>
                <v-btn @click="showRecordDetail(item)">檢視內容</v-btn>
              </span>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-dialog v-model="detailDialog.show" max-width="700">
        <v-card v-if="detailDialog.target">
          <v-card-title class="headline">#{{detailDialog.target.id}} {{detailDialog.target.title}}</v-card-title>
          <v-card-text>
            <div>建立時間：{{detailDialog.target.date}}</div>
            <v-text-field
              v-model="detailDialog.editTitle"
              label="名稱"
              placeholder="輸入可添加紀錄的名稱"
            ></v-text-field>
            <v-combobox
              v-model="detailDialog.editTags"
              hide-selected
              label="標記"
              multiple
              persistent-hint
              small-chips
            >
              <!-- <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      目前沒有任何標記，若要添加請直接輸入然後按下<strong>enter</strong>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template> -->
            </v-combobox>
            <v-data-table
              :headers="detailDialog.headers"
              :items="detailDialog.target.items"
              :items-per-page.sync="detailDialog.pageSize"
              class="elevation-1"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="updateRecord()">Save</v-btn>
            <v-btn color="secondary" @click="closeRecordDetail()">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import axios from '@/lib/axios'
export default {
  data(){
    return {
      headers: [
        { text: '#', value: 'id' },
        { text: '名稱', value: 'title' },
        { text: '建立日期', value: 'date', width: '190px' },
        { text: '標記', value: 'tags' },
        { text: '', value: 'detail-btn' }
      ],
      pageSize: 30,
      totalPageCount: 0,
      lastReqPage: 1,
      records: [],
      detailDialog: {
        target: null,
        show: false,
        pageSize: 30,
        headers: [
          { text: '時間', value: 'date', width: '190px' },
          { text: '內容', value: 'query' }
        ],
        editTags: [],
        editTitle: ''
      }
    }
  },
  async mounted(){
    this.records = await this.getRecords(this.lastReqPage)
  },
  methods: {
    async updateRecord(){
      let target = this.detailDialog.target
      if(target){
        let record = {
          id: target.id,
          title: this.detailDialog.editTitle,
          tags: this.detailDialog.editTags
        }
        record.tags = this.detailDialog.editTags
        try{
          await axios.patch('/pa-news/speech-records', record)
          Object.assign(target, record)
          this.$toast.info('成功')
          this.closeRecordDetail()
        }catch(e){
          this.$toast.error('保存失敗')
        }
      }
    },
    async onChangePage(page){
      // TODO 當切換上下頁時自動更新資料-未完成
      // 當移動到目前的最後一頁時
      if(this.totalPageCount === page && this.records.length % 30 === 0){
        let reqPage = Math.floor(this.records.length / 30) + 1
        if(this.lastReqPage < reqPage){
          this.lastReqPage += 1
          try{
            let newRecords = await this.getRecords(this.lastReqPage)
            this.records = this.records.concat(newRecords)
          }catch(e){}
        }
      }
      console.log(page, this.totalPageCount)
    },
    showRecordDetail(record){
      this.detailDialog.show = true
      this.detailDialog.target = record
      this.detailDialog.editTags = record.tags.slice()
      this.detailDialog.editTitle = record.title
    },
    closeRecordDetail(){
      this.detailDialog.show = false
    },
    async getRecords(page = 1){
      let res = await axios.get('/pa-news/speech-records', {
        params: {
          p: page
        }
      })
      let records = res.data
      for(let record of records){
        record.tags = record.tags || []
        record.items = record.items || []
        record.date = new Date(record.created_at).toLocaleString()
        for(let item of record.items){
          item.date = new Date(item.created_at).toLocaleString()
        }
      }
      console.log('records', records)
      return records
    }
  }
}
</script>

<style scoped>
.background{
  width: 100vw;
  height: 100%;
}
</style>
